

const IS_PRODUCTION = false;
const IS_STAGING = false;
const IS_DEVELOPMENT = true;

const VITE_BASE_URL =
  IS_PRODUCTION
    ? "https://production-backend.getzump.com/api/drivers"
    : IS_STAGING
      ? "https://staging-backend.getzump.com/api/drivers"
      : "https://develop-backend.getzump.com/api/drivers";
// const VITE_API_URL = "https://develop-backend.getzump.com";

export const ENV = {
  VITE_BASE_URL: process.env.BUN_PUBLIC_API_URL,
  IS_PRODUCTION: true,

};
// export const ENV = {
//   VITE_BASE_URL: " http://localhost:9002",
//   VITE_API_URL: "http://localhost:9002",
//   IS_PRODUCTION: false,
// };

export const DISABILITY_OPTIONS = [
  { label: 'No Disability', value: 'None' },
  { label: 'Hearing Impairment', value: 'Deaf' },
  { label: 'Speech Impairment', value: 'Speech Difficulty' },
  { label: 'Visual Impairment', value: 'Visual Difficulty' },
  { label: 'Physical Disability', value: 'Physical Disability' },
];

export const LANGUAGE_OPTIONS = [
  { label: 'English', value: 'english' },
  { label: 'Punjabi', value: 'punjabi' },
  { label: 'Russian', value: 'russian' },
  { label: 'Mandarin Chinese', value: 'mandarin' },
  { label: 'Hindi', value: 'hindi' },
  { label: 'Spanish', value: 'spanish' },
  { label: 'French', value: 'french' },
  { label: 'Arabic', value: 'arabic' },
  { label: 'Portuguese', value: 'portuguese' },
  { label: 'Urdu', value: 'urdu' },
  { label: 'Bengali', value: 'bengali' },
];
